
<div
 class="container-main"
><div class="item-div">
    <div class="class-div">


        <img src="../../assets/images/pending.png" class="circular-image">
    </div>


    <p class="txt-color">{{message}}</p>
</div>
</div>